import React from 'react';
import {createRoot} from 'react-dom/client';
// Carina css resources
// We are using a customized tailwind.css entry point
// Which omits the 'base' layer responsible for normalizing styles
// To prevent conflicts with legacy reset styles
import './style/tailwind.css';
import '@cvent/carina-dsm/dist/css/carina-theme.css';
import {initializeAnalytics} from '@socialtables/analytics';
import {initializeDatadog} from './lib/datadog';
import {AppRouter} from './redesign/routes/routes';
import {AppProviders} from './redesign/provider';
import {ANALYTICS_CONSTANTS} from './analytics/constants';
import {captureTrackingParams} from './redesign/utils/tracking-params';

captureTrackingParams();
initializeDatadog(window.datadogInit);
initializeAnalytics({
  ...window.cventAnalyticsInit,
  constants: ANALYTICS_CONSTANTS,
});
const container = document.getElementById('earth-portal-app');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </React.StrictMode>
);
